module.exports = __webpack_public_path__ + "static/media/spinner.9209e391.gif";